module.exports = __webpack_public_path__ + "media/applicants/device_signup_5-b8b4d81b.jpg";